import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';

import { globalStyles } from 'src/theme/GlobalStyles';
import { createAppTheme } from 'src/theme';
import useSettings from 'src/hooks/useSettings';


import Auth from 'src/components/Auth';
import CookiesNotification from 'src/components/CookiesNotification';
import GoogleAnalytics from 'src/components/GoogleAnalytics';
import ScrollReset from 'src/components/ScrollReset';

import Routes from 'src/routes';

function App() {
  const { settings } = useSettings(); // optional: if you're managing theme dynamically

  const theme = createAppTheme(settings || { theme: 'DEFAULT', responsiveFontSizes: true });

  return (

    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles styles={globalStyles} />
        <SnackbarProvider maxSnack={1}>
          <BrowserRouter>
            <Auth>
              <ScrollReset />
              <GoogleAnalytics />
              <CookiesNotification />
              <Routes />
            </Auth>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </LocalizationProvider>

  );
}

export default App;
